import { isBlank } from './StringUtils';

export const hasToRenderGiftHat = (t, market) => {
  const stringToCheck = t('ficha.producto', `bundle.text.${market}`);
  const bundleLabel = stringToCheck !== undefined && stringToCheck !== null;
  const bundleLabelHasValue = bundleLabel && bundleLabel !== `ficha.producto.bundle.text.${market}` && !isBlank(stringToCheck);
  return bundleLabelHasValue;
};
